import { createHook, createStore } from "react-sweet-state";
var StateDefaults = {
    windowWidth: null,
    windowHeight: null,
    thresholdHideHeaderLinks: false,
    thresholdColumnFooter: false,
    thresholdMenuOnButton: false,
    thresholdHeaderForMobile: false,
    thresholdUnder700: false,
    showMenu: false,
    flexGapSupported: true,
};
var setFlexGapSupport = function (val) {
    return function (store) {
        store.setState(function (draft) {
            draft.flexGapSupported = val;
        });
    };
};
var setWindowDimension = function (width, height) {
    return function (store) {
        store.setState(function (draft) {
            draft.windowWidth = width;
            draft.windowHeight = height;
            draft.thresholdColumnFooter = width < 900;
            draft.thresholdHideHeaderLinks = width < 1000; //840
            draft.thresholdMenuOnButton = width < 1000; //800
            draft.thresholdHeaderForMobile = width < 500;
            draft.thresholdUnder700 = width < 700;
            if (!draft.thresholdMenuOnButton) {
                draft.showMenu = false;
            }
        });
    };
};
var showOrHideMenu = function () {
    return function (store) {
        store.setState(function (draft) {
            draft.showMenu = !draft.showMenu;
        });
    };
};
var hideMenu = function () {
    return function (store) {
        store.setState(function (draft) {
            draft.showMenu = false;
        });
    };
};
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFlexGapSupport: setFlexGapSupport,
        setWindowDimension: setWindowDimension,
        showOrHideMenu: showOrHideMenu,
        hideMenu: hideMenu,
    },
    name: "Responsivity"
});
var useState = createHook(store);
export { StateDefaults as ResponsivityStateDefaults, useState as useResponsivity, };
